import { render, staticRenderFns } from "./transactionNew.vue?vue&type=template&id=44d93886&scoped=true"
import script from "./transactionNew.vue?vue&type=script&lang=js"
export * from "./transactionNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d93886",
  null
  
)

export default component.exports